import React from 'react';
import SearchWithParams from '../components/SearchWithParams';

const SearchByAuthor = props => (
    <SearchWithParams mode="author" {...props} />
);

export default SearchByAuthor;
